import { LayoutDashboard, Users, FileText, FolderArchive, RotateCw, TrendingUp,
  CheckSquare, MessageSquare, BarChart3, Sparkles, Plug, Settings,
  Package, Boxes, Smartphone, LayoutGrid, Warehouse, Tags, ArrowLeftRight, ClipboardList, ScanLine,
  Signal, Radio, Layers, Percent, Calculator, Upload, FileSignature, Receipt, Scale, AlertTriangle,
  PieChart, SlidersHorizontal } from "lucide-react";

const ITEMS = {
  dashboard: { key: "dashboard", to: "/", icon: LayoutDashboard, tkey: "nav.dashboard", perm: "dashboard:read" },
  customers: { key: "customers", to: "/kunden", icon: Users, tkey: "nav.customers", perm: "customers:read" },
  contracts: { key: "contracts", to: "/vertraege", icon: FileText, tkey: "nav.contracts", perm: "contracts:read" },
  documents: { key: "documents", to: "/dokumente", icon: FolderArchive, tkey: "nav.documents", perm: "documents:read" },
  renewals: { key: "renewals", to: "/verlaengerungen", icon: RotateCw, tkey: "nav.renewals", perm: "renewals:read" },
  tasks: { key: "tasks", to: "/aufgaben", icon: CheckSquare, tkey: "nav.tasks", perm: "tasks:read" },
  communication: { key: "communication", to: "/kommunikation", icon: MessageSquare, tkey: "nav.communication", perm: "communication:read" },
  sales: { key: "sales", to: "/vertrieb", icon: TrendingUp, tkey: "nav.sales", perm: "renewals:read" },
  wawi: { key: "wawi", to: "/wawi", icon: LayoutGrid, tkey: "nav.wawi_overview", perm: "wawi:read", module: "warenwirtschaft" },
  wawiArticles: { key: "wawi-articles", to: "/wawi/artikel", icon: Boxes, tkey: "nav.wawi_articles", perm: "wawi:read", module: "warenwirtschaft" },
  wawiCategories: { key: "wawi-categories", to: "/wawi/kategorien", icon: Tags, tkey: "nav.wawi_categories", perm: "wawi:read", module: "warenwirtschaft" },
  wawiStock: { key: "wawi-stock", to: "/wawi/lager", icon: Warehouse, tkey: "nav.wawi_stock", perm: "wawi:read", module: "warenwirtschaft" },
  wawiTransfers: { key: "wawi-transfers", to: "/wawi/umlagerungen", icon: ArrowLeftRight, tkey: "nav.wawi_transfers", perm: "wawi:read", module: "warenwirtschaft" },
  wawiInventur: { key: "wawi-inventur", to: "/wawi/inventur", icon: ClipboardList, tkey: "nav.wawi_inventory", perm: "wawi:read", module: "warenwirtschaft" },
  wawiReceiptScan: { key: "wawi-receipt-scan", to: "/wawi/wareneingang-scan", icon: ScanLine, tkey: "nav.wawi_receipt_scan", perm: "wawi:write", module: "warenwirtschaft" },
  wawiDevices: { key: "wawi-devices", to: "/wawi/geraete", icon: Smartphone, tkey: "nav.wawi_devices", perm: "wawi:read", module: "warenwirtschaft" },
  reports: { key: "reports", to: "/berichte", icon: BarChart3, tkey: "nav.reports", perm: "reports:read" },
  ai: { key: "ai", to: "/ki-assistent", icon: Sparkles, tkey: "nav.ai", perm: "ai:read" },
  integrations: { key: "integrations", to: "/integrationen", icon: Plug, tkey: "nav.integrations", perm: "settings:read" },
  settings: { key: "settings", to: "/einstellungen", icon: Settings, tkey: "nav.settings", perm: "settings:read" },
  // Mobilfunk & Provisionen
  mf: { key: "mf", to: "/mobilfunk", icon: LayoutGrid, tkey: "nav.mf_overview", perm: "mobilfunk:read", module: "mobilfunk" },
  mfProviders: { key: "mf-providers", to: "/mobilfunk/anbieter", icon: Radio, tkey: "nav.mf_providers", perm: "mobilfunk:read", module: "mobilfunk" },
  mfTariffs: { key: "mf-tariffs", to: "/mobilfunk/tarife", icon: Layers, tkey: "nav.mf_tariffs", perm: "mobilfunk:read", module: "mobilfunk" },
  mfPromotions: { key: "mf-promotions", to: "/mobilfunk/aktionen", icon: Percent, tkey: "nav.mf_promotions", perm: "mobilfunk:read", module: "mobilfunk" },
  mfRules: { key: "mf-rules", to: "/mobilfunk/provisionsmodelle", icon: Calculator, tkey: "nav.mf_rules", perm: "mobilfunk:read", module: "mobilfunk" },
  mfImport: { key: "mf-import", to: "/mobilfunk/import", icon: Upload, tkey: "nav.mf_import", perm: "mobilfunk:read", module: "mobilfunk" },
  mfContracts: { key: "mf-contracts", to: "/mobilfunk/abschluesse", icon: FileSignature, tkey: "nav.mf_contracts", perm: "mobilfunk:read", module: "mobilfunk" },
  mfCalc: { key: "mf-calc", to: "/mobilfunk/provisionsberechnung", icon: Receipt, tkey: "nav.mf_calc", perm: "mobilfunk:read", module: "mobilfunk" },
  mfSettlements: { key: "mf-settlements", to: "/mobilfunk/abrechnungen", icon: BarChart3, tkey: "nav.mf_settlements", perm: "mobilfunk:read", module: "mobilfunk" },
  mfReconcile: { key: "mf-reconcile", to: "/mobilfunk/soll-ist", icon: Scale, tkey: "nav.mf_reconcile", perm: "mobilfunk:read", module: "mobilfunk" },
  mfClaims: { key: "mf-claims", to: "/mobilfunk/reklamationen", icon: AlertTriangle, tkey: "nav.mf_claims", perm: "mobilfunk:read", module: "mobilfunk" },
  mfReports: { key: "mf-reports", to: "/mobilfunk/auswertungen", icon: PieChart, tkey: "nav.mf_reports", perm: "mobilfunk:read", module: "mobilfunk" },
  mfSettings: { key: "mf-settings", to: "/mobilfunk/einstellungen", icon: SlidersHorizontal, tkey: "nav.mf_settings", perm: "mobilfunk:read", module: "mobilfunk" },
};

// Grouped, collapsible navigation. A group with no `tkey` renders its items at
// the top level (no header). Groups are hidden automatically when none of their
// items are visible (permissions / module gating).
export const NAV_GROUPS = [
  { key: "top", items: [ITEMS.dashboard] },
  { key: "crm", tkey: "navgrp.crm", icon: Users, items: [ITEMS.customers, ITEMS.contracts, ITEMS.documents, ITEMS.renewals, ITEMS.tasks] },
  { key: "engage", tkey: "navgrp.engage", icon: MessageSquare, items: [ITEMS.communication, ITEMS.sales] },
  { key: "wawi", tkey: "navgrp.wawi", icon: Package, items: [ITEMS.wawi, ITEMS.wawiArticles, ITEMS.wawiCategories, ITEMS.wawiStock, ITEMS.wawiReceiptScan, ITEMS.wawiTransfers, ITEMS.wawiInventur, ITEMS.wawiDevices] },
  { key: "mobilfunk", tkey: "navgrp.mobilfunk", icon: Signal, items: [ITEMS.mf, ITEMS.mfProviders, ITEMS.mfTariffs, ITEMS.mfPromotions, ITEMS.mfRules, ITEMS.mfImport, ITEMS.mfContracts, ITEMS.mfCalc, ITEMS.mfSettlements, ITEMS.mfReconcile, ITEMS.mfClaims, ITEMS.mfReports, ITEMS.mfSettings] },
  { key: "analyze", tkey: "navgrp.analyze", icon: BarChart3, items: [ITEMS.reports, ITEMS.ai] },
  { key: "system", tkey: "navgrp.system", icon: Settings, items: [ITEMS.integrations, ITEMS.settings] },
];

// Flattened list (kept for any consumer that needs a flat nav).
export const NAV_ITEMS = NAV_GROUPS.flatMap((g) => g.items);

export const CONTRACT_STATUS_MAP = {
  entwurf: { label: "Entwurf", cls: "bg-muted text-muted-foreground border-border" },
  ausstehend: { label: "Ausstehend", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  aktiv: { label: "Aktiv", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  verlaengerung_steht_an: { label: "Verlängerung steht an", cls: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20" },
  kuendigung_geplant: { label: "Kündigung geplant", cls: "bg-orange-500/10 text-orange-700 dark:text-orange-300 border-orange-500/20" },
  gekuendigt: { label: "Gekündigt", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
  abgelaufen: { label: "Abgelaufen", cls: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-300 border-zinc-500/20" },
  verlaengert: { label: "Verlängert", cls: "bg-teal-500/10 text-teal-700 dark:text-teal-300 border-teal-500/20" },
};

export const RENEWAL_STAGE_MAP = {
  anstehend: { label: "Anstehend", cls: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20" },
  nicht_kontaktiert: { label: "Nicht kontaktiert", cls: "bg-muted text-muted-foreground border-border" },
  kontaktversuch: { label: "Kontaktversuch", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  kontakt_erfolgreich: { label: "Kontakt erfolgreich", cls: "bg-blue-500/10 text-blue-700 dark:text-blue-300 border-blue-500/20" },
  angebot_vorbereitet: { label: "Angebot vorbereitet", cls: "bg-indigo-500/10 text-indigo-700 dark:text-indigo-300 border-indigo-500/20" },
  angebot_gesendet: { label: "Angebot gesendet", cls: "bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/20" },
  nachfassen: { label: "Nachfassen", cls: "bg-orange-500/10 text-orange-700 dark:text-orange-300 border-orange-500/20" },
  verlaengert: { label: "Verlängert", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  verloren: { label: "Verloren", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
  nicht_zutreffend: { label: "Nicht zutreffend", cls: "bg-muted text-muted-foreground border-border" },
};

export const TASK_STATUS_MAP = {
  offen: { label: "Offen", cls: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20" },
  in_bearbeitung: { label: "In Bearbeitung", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  erledigt: { label: "Erledigt", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
};

export const PRIORITY_MAP = {
  niedrig: { label: "Niedrig", cls: "bg-muted text-muted-foreground border-border" },
  normal: { label: "Normal", cls: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20" },
  hoch: { label: "Hoch", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
};

export const DOC_STATUS_MAP = {
  ungeprueft: { label: "Ungeprüft", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  bestaetigt: { label: "Bestätigt", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
};

export const REF_MODULE_OPTIONS = [
  { value: "kunde", label: "Kunde" },
  { value: "vertrag", label: "Vertrag" },
  { value: "dokument", label: "Dokument" },
  { value: "artikel", label: "Artikel" },
  { value: "wareneingang", label: "Wareneingang" },
  { value: "lager", label: "Lager / Inventur" },
  { value: "geraet", label: "Gerät" },
  { value: "lieferant", label: "Lieferant" },
  { value: "bestellung", label: "Bestellung" },
];

export const REF_MODULE_LABELS = Object.fromEntries(REF_MODULE_OPTIONS.map((o) => [o.value, o.label]));

export const TASK_ORIGIN_MAP = {
  erp: { label: "ERP", cls: "bg-sky-500/10 text-sky-700 dark:text-sky-300 border-sky-500/20" },
  planner: { label: "Planner", cls: "bg-indigo-500/10 text-indigo-700 dark:text-indigo-300 border-indigo-500/20" },
  todo: { label: "To Do", cls: "bg-violet-500/10 text-violet-700 dark:text-violet-300 border-violet-500/20" },
};

export const MS_SYNC_STATUS_MAP = {
  synchronisiert: { label: "Synchronisiert", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  ausstehend: { label: "Sync ausstehend", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  fehler: { label: "Sync-Fehler", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
};

export const CUSTOMER_STATUS_OPTS = ["aktiv", "interessent", "inaktiv", "archiviert"];
export const CATEGORY_LABELS = {
  mobilfunk: "Mobilfunk", mobile_daten: "Mobile Daten", festnetz_internet: "Festnetz & Internet",
  geraeteratenzahlung: "Geräteratenzahlung", strom: "Strom", gas: "Gas",
};


export const MF_VERSION_STATUS_MAP = {
  entwurf: { label: "Entwurf", cls: "bg-muted text-muted-foreground border-border" },
  zur_freigabe: { label: "Zur Freigabe", cls: "bg-amber-500/10 text-amber-700 dark:text-amber-300 border-amber-500/20" },
  freigegeben: { label: "Freigegeben", cls: "bg-emerald-500/10 text-emerald-700 dark:text-emerald-300 border-emerald-500/20" },
  abgelehnt: { label: "Abgelehnt", cls: "bg-red-500/10 text-red-700 dark:text-red-300 border-red-500/20" },
  archiviert: { label: "Archiviert", cls: "bg-zinc-500/10 text-zinc-600 dark:text-zinc-300 border-zinc-500/20" },
};

export const MF_COMMISSION_TYPES = [
  { value: "basis", label: "Basisprovision" },
  { value: "aktionsbonus", label: "Aktionsbonus" },
  { value: "zusatz", label: "Zusatzprovision" },
  { value: "geraete_bonus", label: "Geräte-/Bundle-Bonus" },
  { value: "fest", label: "Feste Provision" },
  { value: "prozent", label: "Prozentuale Provision" },
  { value: "staffel", label: "Stufen-/Mengenbonus" },
  { value: "wiederkehrend", label: "Wiederkehrende Provision" },
  { value: "storno", label: "Storno / Rückbelastung" },
  { value: "korrektur", label: "Korrektur (negativ)" },
];
